"use client";

import { useState } from "react";
import VimeoVideo from "./VimeoVideo/VimeoVideo";

export default function Demos({ demos }) {
    const [selectedDemo, setSelectedDemo] = useState(demos[0]);

    return (
        <>
            <div
                className={`${
                    demos.length >= 5
                        ? "flex-col flex divide-y-2 divide-primary/10"
                        : "md:inline-flex flex md:flex-row flex-col items-center md:divide-y-0 divide-y-2 divide-primary/10"
                } rounded-2xl overflow-hidden`}
            >
                {demos.map((demo, index) => (
                    <article
                        key={`demo-${index}`}
                        className={`px-5 py-1.5 cursor-pointer md:w-auto w-full text-center ${
                            selectedDemo.title === demo.title
                                ? "bg-primary text-white"
                                : "bg-primary/10 hover:bg-primary/30 duration-100 text-primary"
                        }`}
                        onClick={() => setSelectedDemo(demo)}
                    >
                        {demo.title}
                    </article>
                ))}
            </div>
            <article className="mt-5 rounded-2xl overflow-hidden relative aspect-[16/9] border">
                <VimeoVideo
                    videoId={selectedDemo.videoId}
                    thumb={selectedDemo.thumb}
                />
            </article>
        </>
    );
}
